import type { Prospect } from 'src/graphql/types';

export const mapApiResponseToStore = (prospectResponse: Prospect) => ({
  ...prospectResponse,
  ...mapInteractionCountsToStore(prospectResponse),
  ...mapSubmissionToStore(prospectResponse),
});

const mapInteractionCountsToStore = ({
  noteCount,
  emailCount,
  prospectCount,
  attachments,
}: Prospect) => ({
  notes: { noteCount },
  prospectEmailStore: { emailCount },
  candidateStore: { prospectCount },
  attachmentsStore: { attachmentList: attachments },
});

const mapSubmissionToStore = ({ submission }: Prospect) => ({
  hasRRError: submission?.__typename.endsWith('Error') ?? false,
  roleRequirements:
    submission?.__typename === 'Submission'
      ? submission?.roleRequirements ?? []
      : [],
});
